// extracted by mini-css-extract-plugin
module.exports = {"layout":"offset-callout_layout__RrMqM","content":"offset-callout_content__qjyQ5","image":"offset-callout_image__kq9DD"};